import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { MirrorAuditListPageResult } from 'src/api_v2/mirror-audit/types';
import IPagination from 'src/models/pagination';

export type MirrorAuditType = {
  id: number;
  description?: string;
  name?: string;
  action?: string;
  modifiedDate?: string;
  createdDate?: string;
  reservationStatus?: string;
  uuid?: string;
  updatedBy?: {
    email?: string,
    id?: number
  };
};
export interface MirrorAuditListState extends IPagination {
  total: number;
  data: MirrorAuditType[];
  loading: boolean;
  error: string;
  deleted: boolean;
  uploadCredit?: number;
  exporting: boolean;
}

export const initialState: MirrorAuditListState = {
  data: [],
  total: 0,
  page: 1,
  pageSize: 50,
  sort: 'modifiedDate|desc',
  search: '',
  loading: false,
  error: '',
  deleted: false,
  uploadCredit : 0,
  exporting: false
};

const MirrorAuditListSlice = createSlice({
  name: 'mirrorAuditlist',
  initialState,
  reducers: {
    resetState: () => initialState,
    fetchMirrorAuditList(state: MirrorAuditListState) {
      state.loading = true;
    },
    mirrorAuditListFetched(
      state: MirrorAuditListState,
      action: PayloadAction<MirrorAuditListPageResult>
    ) {
      state.loading = false;
      state.error = '';
      state.data = action.payload.data;
      state.total = action.payload.total;
    },
    mirrorAuditListFetchedError(state: MirrorAuditListState) {
      state.loading = false;
      state.error = 'Fail to fetch mirrorAudit list';
    },
    setCurrentPage(state: MirrorAuditListState, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setSearch(state: MirrorAuditListState, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    setSort(state: MirrorAuditListState, action: PayloadAction<string>) {
      state.sort = action.payload;
    },
    deleteMirrorAudit(state: MirrorAuditListState, action: PayloadAction<number>) {
      state.loading = true;
      state.error = '';
      state.deleted = false;
    },
    mirrorAuditDeleted(state: MirrorAuditListState) {
      state.loading = false;
      state.deleted = true;
    },
    mirrorAuditDeletedError(state: MirrorAuditListState, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetDeleted(state: MirrorAuditListState) {
      state.deleted = false;
    },
    setPageSize(state: MirrorAuditListState, action: PayloadAction<number>) {
      state.pageSize = action.payload;
    },
    fetchTotalMirrorAuditList(state: MirrorAuditListState) {
      state.loading = true;
    },
    fetchRemainingCredit(state: MirrorAuditListState, action: PayloadAction<number>) {
      state.loading = true;
    },
    fetchedRemainingCredit(
      state: MirrorAuditListState,
      action: PayloadAction<number>
    ) {
      state.loading = false;
      state.uploadCredit = action.payload || 0;
    },
    fetchedRemainingCreditError(state: MirrorAuditListState) {
      state.loading = false;
    },
    resetError(state: MirrorAuditListState) {
      state.error = '';
    },
    exportFile(state: MirrorAuditListState) {
      state.exporting = true
    },
    unscreenHistoryExported(state: MirrorAuditListState) {
      state.exporting = false
    },
    unscreenHistoryExportedFail(state: MirrorAuditListState) {
      state.exporting = false
    }
  }
});

export const { actions, reducer, name: sliceKey } = MirrorAuditListSlice;
